<template>
  <a-input
    ref="el"
    size="large"
    type="email"
    v-bind="{ ...$attrs, ...$props }"
    v-on="listeners"
  />
</template>

<script>
  import fixListeners from '@/utils/fixListeners';

  export default {
    name: 'UiEmailInput',
    inheritAttrs: false,
    computed: {
      ...fixListeners()
    },
  }
</script>

<style scoped>
</style>
